export default __webpack_public_path__ + "static/media/zawodnik6.7a90b8b7.png";